<template>
    <p v-if="insurance === Insurance.INSURANCE_ACTION_REQUIRED">Pending</p>
    <InsuranceBadgeBase
        v-else
        v-bind="badgeProps"
    />
</template>

<script setup lang="ts">
import { BASE_INSURANCE_BADGE_MAP } from '@/components/shared/InsuranceBadge';
import { Insurance } from '@/types/closinglock.types.js';
import type { DsBadgeProps } from '@ds/badge/DsBadge.vue';
import { computed } from 'vue';
import InsuranceBadgeBase from './InsuranceBadgeBase.vue';

type BadgeContext = 'table' | 'report';

const props = withDefaults(
    defineProps<{
        insurance: Insurance;
        context?: BadgeContext;
    }>(),
    {
        context: 'table',
    },
);

const REPORT_OVERRIDES: Partial<Record<Insurance, Partial<DsBadgeProps>>> = {
    [Insurance.INSURANCE_INSURED]: { text: 'Insured by Closinglock' },
};

const badgeProps = computed<DsBadgeProps>(() => {
    const baseProps = BASE_INSURANCE_BADGE_MAP[props.insurance] ?? BASE_INSURANCE_BADGE_MAP[Insurance.INSURANCE_NOT_INSURED];
    const reportProps = props.context === 'report' ? REPORT_OVERRIDES[props.insurance] : undefined;

    return {
        ...baseProps,
        ...reportProps,
    };
});
</script>
